import { IGetMedicaoTeceirizacaoDropDownUseCase } from "../../../presentation/useCases/read/get_medicao_teceirizacao_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetMedicaoTeceirizacaoDropDownUseCase
 */

export class GetMedicaoTeceirizacaoDropDownUseCase implements IGetMedicaoTeceirizacaoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getMedicaoTeceirizacaoDropDown(): Promise<DropDown[]> {
    return await this.repository.getMedicaoTerceirizacaoDropDown()

  }
}
